import React, { Component } from 'react'
import { 
  Button
} from '@blueprintjs/core';
import { action } from 'mobx';
import { observer, inject } from 'mobx-react';
import SearchFiltersToolbar from 'components/SearchFiltersToolbar';
import SearchFiltersSearchButton from 'components/SearchFiltersSearchButton';

@inject('store', 'viewStore') @observer
class QuestionGroupSearch extends Component {

  @action
  search() {
    let viewStore = this.props.viewStore;
    viewStore.questionGroupSearch.page = 1;
    this.props.viewStore.questionGroups();
  }

  @action
  onSearchTermChange(e) {
    let {
      props: {
        viewStore: {
          questionGroupSearch
        }
      }
    } = this;
    this.props.viewStore.questionGroupSearch = {
      ...questionGroupSearch,
      term: e.target.value
    }
  }

  onEnter(event) {
    if (event.key === "Enter") {
      this.search()
    }
  }

  render() {
    let {
      props: {
        viewStore,
        store,
        viewStore: {
          questionGroupSearch: { term }
        }
      }
    } = this;
    if(term == '*'){
      term = '';
    }
    return (
      <SearchFiltersToolbar
        searchButton={
          <SearchFiltersSearchButton onClick={this.search.bind(this)} />
        }
        actions={
          <Button icon={'plus'} small={true} onClick={() => viewStore.questionGroupAdd()}>
            Add Question Group
          </Button>
        }
      >
        <input
          type="text"
          className="bp3-input search-filters-toolbar__field-wide"
          placeholder="Label"
          onChange={this.onSearchTermChange.bind(this)}
          defaultValue={term}
          onKeyPress={this.onEnter.bind(this)}
        />
      </SearchFiltersToolbar>
    )
  }
}

export default QuestionGroupSearch;